import { render, staticRenderFns } from "./block-document-signatures.vue?vue&type=template&id=019c5283&scoped=true&lang=pug"
import script from "./block-document-signatures.vue?vue&type=script&lang=js"
export * from "./block-document-signatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019c5283",
  null
  
)

export default component.exports